import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  FooterComponent,
  HeaderComponent,
  IFooterLink,
  IMenu,
  deleteCookie,
  getCookie,
  ISidebar,
  SidebarComponent,
  ModalComponent,
  TemplateModalEnum,
  ButtonComponent,
  ButtonTypesEnum,
  fromHoursToMilliseconds,
  LoaderComponent,
  HandleScreenService,
  WarningModalComponent,
  NotificationNewComunication,
  setCookie,
} from '@poste-click-connect/shared-ui';
import { FacadeService } from './services/facade.service';
import {
  primaryMenuLogged,
  primaryMenuLoggedNoSurvey,
  primaryMenuLottomatica,
  primaryMenuLottomaticaNoSurvey,
  primaryMenuNotLogged,
  secondaryMenu,
  secondaryMenuMobile,
} from './utils/menu-config';
import { Observable, Subscription, filter } from 'rxjs';
import {
  sidebarVoices,
  sidebarVoicesNoMagazzino,
} from './utils/sidebar-config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { Path } from './enums/path.enum';
import { ClientActivitiesService } from './services/client-activities.service';
import { ParcelSalesService } from './services/parcel-sales.service';
import { ClientAcceptanceService } from './services/client-acceptance.service';
import { InterceptorService } from './services/interceptor.service';
import { PackageWarehouseService } from './services/package-warehouse.service';
import { CurierActivitiesService } from './services/curier-activities.service';
import {
  setDriverConsegnaFormDataPin,
  setDriverConsegnaFormDataNoPin,
  setDriverConsegnaPinForm,
  setDriverConsegnaNoPinForm,
  setDriverVenditaDettaglio,
  setDriverVenditaFormCodice,
  setDriverAccettazioneDettaglio,
  setDriverAccettazioneFormCodice,
  setDriverAccettazioneCorriereDettaglio,
  setDriverAccettazioneCorriere,
  setDriverAccettazioneInfo,
  setDriverConsegnaCorriereDettaglioConPalmare,
  setDriverConsegnaCorriereDettaglioInitialStep,
} from './utils/guida-flash.utils';
import { ActiveServiceEnum } from './enums/active-service.enum';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    FooterComponent,
    HeaderComponent,
    ModalComponent,
    RouterModule,
    SidebarComponent,
    TranslateModule,
    UpperCasePipe,
    LoaderComponent,
    WarningModalComponent,
  ],
  selector: 'poste-click-connect-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, OnInit {
  public buttonTypeSecondary: ButtonTypesEnum = ButtonTypesEnum.OUTLINE;
  public footerLink: IFooterLink = {
    label: 'Termini e condizioni',
    url: 'termini-condizioni',
  };
  public isLogged: boolean = false;
  public isMaintainance: boolean = false;
  public showNotificationBanner: boolean = false;
  public notificationBannerText: string = '';
  public isBackMenuVisible: boolean = false;
  public isSecondMenuVisible: boolean = false;
  public showIconBacheca: boolean = false;
  public isExpiredObjectsBeforeToday: boolean = false;
  public isModalVisible: boolean = false;
  public closeMenuMobile: boolean = false;
  public primaryMenu: IMenu[] = primaryMenuNotLogged;
  public primaryMenuMobile: IMenu[] = primaryMenuNotLogged;
  public secondaryMenu: IMenu[] = [];
  public sidebarVoices: ISidebar[] = sidebarVoices;
  public templateModal: TemplateModalEnum = TemplateModalEnum.WARNING;
  public buttonType = ButtonTypesEnum;
  public templateModalEnum = TemplateModalEnum;
  public openAlertModal: boolean = false;
  public linkSidebarSelected: string = '';
  public isLottomatica: boolean = false;
  public version$: Observable<string> =
    this.facade.footer.selectApplicationVersion$;
  private frequenceExpiredObjectModal: number = 0;
  private isModalEnabled: boolean = false;
  private subs: Subscription[] = [];
  private surveryUrl?: string;
  private showSurvey: boolean = false;
  private showMagazzinoMateriali: boolean = false;

  public driverObj: any;

  get pathBackHeader(): string {
    return this.isLottomatica
      ? 'homepage'
      : `${Path.ATTIVITA_CLIENTE}/${Path.CONSEGNA_CLIENTE}`;
  }

  get isMobile(): boolean {
    return this.handleScreenService.isMobile();
  }

  get tabInProgress(): boolean {
    if (this.clientActivitiesService.showFormParcelData) {
      return true;
    }
    if (this.parcelSalesService.showFormSalesData) {
      return true;
    }
    if (this.clientAcceptanceService.isSecondStep) {
      return true;
    }
    if (this.curierActivitiesService.isCurierAcceptanceSecondStep) {
      return true;
    }
    if (this.curierActivitiesService.isCurierDeliverySecondStep) {
      return true;
    }
    return false;
  }

  get labelBackLinkHome(): string {
    return this.isLottomatica ? 'LINK:home' : 'HEADER:back--activity-delivery';
  }

  get isActiveCloseBoxWorkflow(): boolean {
    return this.packageWarehouseService.isCloseBoxWorkflow;
  }

  get isDevileryWithPin(): boolean {
    return this.clientActivitiesService.isDevileryWithPin;
  }
  get isInitialStep(): boolean {
    return this.curierActivitiesService.isInitialStep;
  }

  get isLoginCambioPassword(): boolean {
    return this.interceptorService.isLoginCambioPassword;
  }
  get isGuidaFlashForm(): boolean {
    return this.clientAcceptanceService.isGuidaFlashForm;
  }

  get isBachecaDetail(): boolean {
    return this.router.url.includes(Path.BACHECA);
  }

  constructor(
    public interceptor: InterceptorService,
    private facade: FacadeService,
    private router: Router,
    private translate: TranslateService,
    private handleScreenService: HandleScreenService,
    private clientActivitiesService: ClientActivitiesService,
    private parcelSalesService: ParcelSalesService,
    private clientAcceptanceService: ClientAcceptanceService,
    private packageWarehouseService: PackageWarehouseService,
    private curierActivitiesService: CurierActivitiesService,
    private interceptorService: InterceptorService
  ) {
    (window as any).pdfWorkerSrc = 'assets/vendor/pdf.worker.js';
    translate.setDefaultLang('it');
    translate.use('it');
  }

  ngOnInit(): void {
    (window as any).setValueFromBarcode = (barcode: string) => {
      const setBarcode = new CustomEvent('setBarcodeEvent', {
        detail: {
          barcode,
        },
      });
      document.dispatchEvent(setBarcode);
    };
    const token = this.parseAccessTokenCookie(getCookie('accessToken'));
    const servizi = this.parseServiziCookie(getCookie('servizi'));

    this.facade.successLogin({ authToken: token, servizi });

    const isLottomatica = getCookie('isLottomatica');

    if (isLottomatica === 'Y') {
      this.facade.setIsLottomatica(true);
    }

    this.facade.retrieveConfig(token);
    this.retrieveIsMaintainance();
    this.retrieveExpiredObject();
    this.retrieveTokenStore();
    setTimeout(() => {
      this.retrieveSurveyUrl();
    }, 100);
    this.retrieveUrl();
    this.retrieveQueryParams();
    this.retrieveNotificationPresent();
    this.retrieveServiziAbilitati();
    this.interceptor.subscriberErrorMessage();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  navigation(selected: string, isFromSidebarOrHeader?: boolean): void {
    if (selected === 'flash') {
      this.setDriver();
      return;
    }

    if (this.isActiveCloseBoxWorkflow) {
      return;
    }
    if (this.isLoginCambioPassword) {
      if (selected === 'logout') {
        this.facade.logout();
        this.router.navigateByUrl('/login');
        deleteCookie('accessToken', window.location.hostname);
      } else {
        return;
      }
    }
    switch (selected) {
      case 'survey':
        window.open(this.surveryUrl as string, '_self');
        break;
      case 'logout':
        if (this.clientAcceptanceService.isSecondStep) {
          this.clientAcceptanceService.isSecondStep = false;
        }
        this.facade.logout();
        this.facade.submitLogout();
        this.router.navigateByUrl('/login');
        deleteCookie('accessToken', window.location.hostname);
        deleteCookie('isLottomatica', window.location.hostname);
        break;
      case 'homepage':
        window.localDeviceManager.app_disconnect();
        break;
      default:
        if (isFromSidebarOrHeader && this.isMobile) {
          this.closeMenuMobile = true;
        }
        if (isFromSidebarOrHeader && this.tabInProgress) {
          this.linkSidebarSelected = selected;
          this.openAlertModal = true;
          return;
        }

        this.router.navigateByUrl(`/${selected}`);
    }
  }

  setActiveLink(): void {
    if (this.isLogged) {
      const { url } = this.router;

      if (this.showMagazzinoMateriali) {
        this.sidebarVoices = sidebarVoices.map((voice) => ({
          ...voice,
          isActive: url.indexOf(voice.url) >= 0,
        }));
      } else {
        this.sidebarVoices = sidebarVoicesNoMagazzino.map((voice) => ({
          ...voice,
          isActive: url.indexOf(voice.url) >= 0,
        }));
      }
    }
  }

  resetToggleMenuMobile(event: boolean): void {
    this.closeMenuMobile = event;
  }

  postponeModal(): void {
    this.isModalVisible = false;

    if (this.isModalEnabled) {
      setTimeout(() => {
        this.isModalVisible = true;
      }, this.frequenceExpiredObjectModal);
    }
  }

  wizardBoxless(): void {
    this.isModalVisible = false;
    this.facade.retrieveBeniContoDeposito();
    this.packageWarehouseService.setIsCloseBoxWorkflow(true);
    this.router.navigateByUrl(
      `/${Path.MAGAZZINO_PACCHI}/${Path.CONTO_DEPOSITO}`
    );
  }

  closeInterceptor(): void {
    if (this.interceptor.isApiError) {
      this.interceptor.closeModalError();
    } else {
      this.interceptor.effectiveLogout();
    }
  }

  private retrieveIsMaintainance(): void {
    this.subs = [
      ...this.subs,
      this.facade.guard.selectIsMaintainance$
        .pipe(filter((value) => value !== undefined))
        .subscribe((value) => {
          this.isMaintainance = !!value;
        }),
    ];
  }

  private retrieveExpiredObject(): void {
    this.subs = [
      ...this.subs,
      this.facade.generic.selectExpiredObjectConfig$
        .pipe(
          filter(
            (value) =>
              value.oggettiScadutiOggi || value.oggettiScadutiPrimaDiOggi
          )
        )
        .subscribe(
          (value: {
            giornataLavorativa: boolean;
            oggettiScadutiOggi: boolean;
            oggettiScadutiPrimaDiOggi: boolean;
            frequenzaPopupOggettiScaduti: number;
          }) => {
            this.frequenceExpiredObjectModal =
              fromHoursToMilliseconds(value.frequenzaPopupOggettiScaduti) || 0;
            this.isExpiredObjectsBeforeToday = value.oggettiScadutiPrimaDiOggi;

            if (
              value.giornataLavorativa &&
              (value.oggettiScadutiOggi || value.oggettiScadutiPrimaDiOggi)
            ) {
              this.isModalEnabled = true;
              if (!this.isBachecaDetail) {
                this.isModalVisible = true;
              }
            }
          }
        ),
    ];
  }

  private retrieveQueryParams(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const channel = urlParams.get('channel');

    if (channel) {
      this.interceptor.isLottomatica = !!channel;
      const services = urlParams.get('servizi');

      this.facade.retriveNotification();
      this.facade.retriveSurvey();
      this.facade.retriveRegexDhl();
      this.facade.retriveExpiredObject();

      const today = new Date();
      const expirationDate = today.getTime() + 500000;

      setCookie(
        'isLottomatica',
        'Y',
        `${expirationDate}`,
        window.location.hostname
      );

      // Override Services if visible in URL
      if (services) {
        const servizi = services?.split(',') || [];

        this.facade.successLogin({
          authToken: '',
          servizi: servizi,
        });

        setCookie(
          'servizi',
          JSON.stringify(servizi),
          `${expirationDate}`,
          window.location.hostname
        );
      }
    }

    this.facade.setIsLottomatica(!!channel);
  }

  private retrieveSurveyUrl(): void {
    this.subs = [
      ...this.subs,
      this.facade.header.selectSurvey$
        .pipe(filter((url: string) => Boolean(url)))
        .subscribe((url: string) => {
          this.surveryUrl = url;
        }),
      this.facade.header.selectShowSurvey$.subscribe((response) => {
        this.showSurvey = response;
        this.checkSurveyHeader();
      }),
    ];
  }

  private retrieveTokenStore(): void {
    this.subs = [
      ...this.subs,
      this.facade.guard.selectToken$
        .pipe(filter((token: string) => Boolean(token)))
        .subscribe(() => {
          this.isLogged = true;
          this.loggedConfig();
        }),
      this.facade.guard.selectToken$
        .pipe(filter((token: string) => !token))
        .subscribe(() => {
          this.primaryMenu = primaryMenuNotLogged;
          this.primaryMenuMobile = primaryMenuNotLogged;
          this.secondaryMenu = [];
          this.sidebarVoices = [];
          this.isLogged = false;
          this.isSecondMenuVisible = true;
        }),
      this.facade.clientAcceptance.selectIsLottomatica$
        .pipe(filter((isLottomatica: boolean) => isLottomatica))
        .subscribe((isLottomatica: boolean) => {
          this.isLottomatica = isLottomatica;
          this.isLogged = true;
          this.loggedConfig();
          this.checkSurveyHeader();
        }),
    ];
  }

  private retrieveUrl(): void {
    this.verifyIsBackMenuVisible(this.router.url);
    this.setClassRoot();
    this.subs = [
      ...this.subs,
      this.router.events
        .pipe(filter((event: Event) => event instanceof NavigationEnd))
        .subscribe((event: Event) => {
          const { url } = event as NavigationEnd;

          this.verifyIsBackMenuVisible(url);

          document.querySelector('.container-scroller')?.scroll(0, 0);

          this.setActiveLink();
        }),
    ];
  }

  private retrieveNotificationPresent(): void {
    this.subs = [
      ...this.subs,
      this.facade.generic.selectIsNotificationPresent$.subscribe((response) => {
        if (
          response &&
          response?.nuovaComunicazione === '1' &&
          response?.messaggioHeader
        ) {
          this.notificationBannerText = response.messaggioHeader || '';
          this.showNotificationBanner = true;
          document.querySelector('#root')?.classList.remove('grid-rows-body');
          document
            .querySelector('#root')
            ?.classList.add('grid-rows-notification');
        } else {
          this.notificationBannerText = '';
          this.showNotificationBanner = false;
          document
            .querySelector('#root')
            ?.classList.remove('grid-rows-notification');
          document.querySelector('#root')?.classList.add('grid-rows-body');
        }
        this.showIconBacheca =
          response.nuovaComunicazione ===
          NotificationNewComunication.COMUNICATION;
      }),
    ];
  }

  private verifyIsBackMenuVisible(url: string): void {
    this.isBackMenuVisible =
      url.indexOf(Path.GESTIONE_PUNTOPOSTE) >= 0 ||
      url.indexOf(Path.BACHECA) >= 0;
  }

  private parseServiziCookie(serviziCookie: string): string[] {
    if (
      !serviziCookie ||
      serviziCookie === 'undefined' ||
      serviziCookie === 'null'
    ) {
      return [];
    }

    try {
      const parsed = JSON.parse(serviziCookie);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private parseAccessTokenCookie(tokenCookie: string): string {
    if (!tokenCookie || tokenCookie === 'undefined' || tokenCookie === 'null') {
      return '';
    }

    return tokenCookie;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(_event?: UIEvent) {
    this.handleScreenService.updateScreenWidth();
    if (!this.isLogged) {
      this.secondaryMenu = [];
      return;
    }

    if (this.isMobile) {
      this.secondaryMenu = secondaryMenuMobile;
    } else {
      this.secondaryMenu = secondaryMenu;
    }

    this.setClassRoot();
  }

  private setClassRoot(): void {
    if (this.isMobile) {
      document.querySelector('#root')?.classList.remove('grid');
      document.querySelector('#root')?.classList.remove('grid-rows-body');
      document.querySelector('body')?.classList.remove('overflow-hidden');
    } else {
      document.querySelector('#root')?.classList.add('grid');
      if (this.showNotificationBanner) {
        document
          .querySelector('#root')
          ?.classList.add('grid-rows-notification');
      } else {
        document.querySelector('#root')?.classList.add('grid-rows-body');
      }
      document.querySelector('body')?.classList.add('overflow-hidden');
    }
  }

  closeModal(toggle: boolean): void {
    if (toggle) {
      this.clientActivitiesService.setShowFormParcelData(false);
      this.parcelSalesService.setShowFormSalesData(false);
      this.clientAcceptanceService.isSecondStep = false;
      this.curierActivitiesService.setCurierDeliverySecondStep(false);
      this.curierActivitiesService.setCurierAcceptanceSecondStep(false);
      this.router.navigateByUrl(`/${this.linkSidebarSelected}`);
    }
    this.openAlertModal = false;
  }

  private loggedConfig(): void {
    this.isSecondMenuVisible = true;

    if (this.isLoginCambioPassword) {
      this.primaryMenu = primaryMenuNotLogged;
      this.primaryMenuMobile = primaryMenuNotLogged;
    } else {
      this.primaryMenu = this.isLottomatica
        ? primaryMenuLottomaticaNoSurvey
        : this.isLogged
        ? primaryMenuLoggedNoSurvey
        : primaryMenuNotLogged;
      this.primaryMenuMobile = this.isLottomatica
        ? primaryMenuLottomaticaNoSurvey
        : this.isLogged
        ? primaryMenuLoggedNoSurvey
        : primaryMenuNotLogged;
    }

    if (this.isMobile) {
      this.secondaryMenu = secondaryMenuMobile;
    } else {
      this.secondaryMenu = secondaryMenu;
    }

    this.sidebarVoices = this.showMagazzinoMateriali
      ? sidebarVoices
      : sidebarVoicesNoMagazzino;
    this.checkSurveyHeader();
  }

  private checkSurveyHeader(): void {
    if (this.showSurvey) {
      if (this.isLoginCambioPassword) {
        this.primaryMenu = primaryMenuNotLogged;
        this.primaryMenuMobile = primaryMenuNotLogged;
      } else if (this.isLogged) {
        this.primaryMenu = this.isLottomatica
          ? primaryMenuLottomatica
          : primaryMenuLogged;
        this.primaryMenuMobile = this.isLottomatica
          ? primaryMenuLottomatica
          : primaryMenuLogged;
      }
    }
  }

  private setDriver(): void {
    this.driverObj = null;
    //ATTIVITA CLIENTE - CONSEGNA AL CLIENTE
    if (this.router.url.includes(Path.CONSEGNA_CLIENTE)) {
      if (this.tabInProgress) {
        if (this.isDevileryWithPin) {
          setDriverConsegnaFormDataPin();
        } else {
          setDriverConsegnaFormDataNoPin();
        }
      } else {
        if (this.isDevileryWithPin) {
          setDriverConsegnaPinForm();
        } else {
          setDriverConsegnaNoPinForm();
        }
      }
    }
    //ATTIVITA CLIENTE - VENDITA
    if (this.router.url.includes(Path.VENDITA)) {
      if (this.tabInProgress) {
        setDriverVenditaDettaglio();
      } else {
        setDriverVenditaFormCodice();
      }
    }
    //ATTIVITA CLIENTE - ACCETTAZIONE CLIENTE
    if (this.router.url.includes(Path.ACCETTAZIONE_CLIENTE)) {
      if (this.tabInProgress) {
        if (this.isGuidaFlashForm) {
          setDriverAccettazioneDettaglio();
        } else {
          setDriverAccettazioneInfo();
        }
      } else {
        setDriverAccettazioneFormCodice();
      }
    }
    //ATTIVITA CORRIERE - CONSEGNA CORRIERE
    if (this.router.url.includes(Path.CONSEGNA_CORRIERE)) {
      if (this.curierActivitiesService.isInitialStep) {
        setDriverConsegnaCorriereDettaglioInitialStep();
      } else if (
        this.curierActivitiesService.isCurierAcceptancePaddleWorkflow
      ) {
        setDriverConsegnaCorriereDettaglioConPalmare();
      }
    }
    //ATTIVITA CORRIERE - ACCETTAZIONE CORRIERE
    if (this.router.url.includes(Path.ACCETTAZIONE_CORRIERE)) {
      if (this.tabInProgress) {
        setDriverAccettazioneCorriereDettaglio();
      } else {
        setDriverAccettazioneCorriere();
      }
    }
  }

  sidebarVoicesActive(noMagazzino: boolean): void {
    const { url } = this.router;

    if (noMagazzino) {
      this.sidebarVoices = sidebarVoicesNoMagazzino.map((voice) => ({
        ...voice,
        isActive: url.indexOf(voice.url) >= 0,
      }));
    } else {
      this.sidebarVoices = sidebarVoices.map((voice) => ({
        ...voice,
        isActive: url.indexOf(voice.url) >= 0,
      }));
    }
  }

  private retrieveServiziAbilitati(): void {
    this.facade.login.selectServizi$.subscribe((servizi) => {
      if (
        servizi.findIndex(
          (servizio) =>
            servizio === ActiveServiceEnum.CREAZIONE_ORDINE_MATERIALI ||
            servizio === ActiveServiceEnum.STORICO_ORDINE_MATERIALI ||
            servizio === ActiveServiceEnum.CREAZIONE_RESO_MATERIALI
        ) !== -1
      ) {
        this.showMagazzinoMateriali = true;
      }
    });
  }
}
